import { put, select, takeEvery } from "redux-saga/effects"
import { axiosPut, del, get, post } from "helpers/api_helper"
import {
  showSavingModal,
  hideSavingModal,
  putMenuItemSuccess,
  setSelectedFeature,
  setIsOutdated,
} from "../actions"
import {
  addWebLinkFailed,
  addWebLinkSuccess,
  deleteWebLinkFailed,
  deleteWebLinkSuccess,
  getWebLinkClicksFailed,
  getWebLinkClicksSuccess,
  getWebLinkFailed,
  getWebLinkListFailed,
  getWebLinkListSuccess,
  getWebLinkSuccess,
  hideDeleteWebLinkModal,
  updateWebLinkFailed,
  updateWebLinkOrderFailed,
  updateWebLinkOrderSuccess,
  updateWebLinkStatusFailed,
  updateWebLinkStatusSuccess,
  updateWebLinkSuccess,
} from "./actions"
import {
  ADD_WEB_LINK,
  DELETE_WEB_LINK,
  GET_WEB_LINK,
  GET_WEB_LINK_CLICKS,
  GET_WEB_LINK_LIST,
  UPDATE_WEB_LINK,
  UPDATE_WEB_LINK_ORDER,
  UPDATE_WEB_LINK_STATUS,
} from "./actionTypes"
function* addWebLink({ payload: params }) {
  try {
    yield put(showSavingModal())
    const containerResponse = yield post(
      "/admin/menu/container",
      params.container
    )
    for (let link of params.links) {
      const response = yield post("/admin/promo", {
        ...link,
        menu_container_id: containerResponse.id,
      })
    }
    if (params.container.menu_feature === 1) {
      const menuItem = yield axiosPut("/admin/menu-item", {
        entity_id: containerResponse.id,
        menu_item_id: containerResponse.menu_item_id,
      })
      yield put(putMenuItemSuccess(menuItem))
      yield put(setSelectedFeature(menuItem))
      yield put(setIsOutdated(true))
    } else {
      const webLinkListResponse = yield get("/menu/container", {
        params: {
          event_id: params.container.event_id,
          menu_item_id: params.container.menu_item_id,
        },
      })
      yield put(getWebLinkListSuccess(webLinkListResponse))
    }
    const webLink = yield get(`/admin/menu/container/${containerResponse.id}`)
    yield put(addWebLinkSuccess(webLink))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(addWebLinkFailed(error))
  }
}

function* getWebLink({ payload: params }) {
  try {
    const response = yield get(`/admin/menu/container/${params}`)
    const destroyed = yield select(state => state.WebLink.destroyed)
    if (!destroyed) {
      yield put(getWebLinkSuccess(response))
    }
  } catch (error) {
    yield put(getWebLinkFailed(error))
  }
}

function* updateWebLink({ payload: params }) {
  try {
    yield put(showSavingModal())

    if (params.deletableLinkIds.length > 0) {
      for (let linkId of params.deletableLinkIds) {
        yield del(`/admin/promo/${linkId}`)
      }
    }

    if (params.newLinks.length > 0) {
      for (let link of params.newLinks) {
        yield post("/admin/promo", {
          ...link,
          menu_container_id: params.container.id,
        })
      }
    }

    if (params.updatedLinks.length > 0) {
      for (let link of params.updatedLinks) {
        yield axiosPut(`/admin/promo/${link.id}`, link)
      }
    }

    const response = yield axiosPut(
      `/admin/menu/container/${params.container.id}`,
      params.container,
      {
        menu_item_id: params.container.menu_item_id,
      }
    )
    if (params.container.menu_feature === 1) {
      const containerResponse = yield get(
        `/admin/menu/container/${params.container.id}`
      )
      yield put(getWebLinkSuccess(containerResponse))
    }
    yield put(updateWebLinkSuccess(response))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(updateWebLinkFailed(error))
  }
}

function* getWebLinkList({ payload: params }) {
  try {
    const response = yield get("/menu/container", { params })
    const destroyed = yield select(state => state.WebLink.listDestroyed)
    if (!destroyed) {
      yield put(getWebLinkListSuccess(response))
    }
  } catch (error) {
    yield put(getWebLinkListFailed(error))
  }
}

function* deleteWebLink({ payload: params }) {
  try {
    const response = yield del(`/admin/menu/container/${params.id}`, {
      menu_item_id: params.menu_item_id,
    })
    yield put(deleteWebLinkSuccess(response))
    yield put(hideDeleteWebLinkModal())
  } catch (error) {
    yield put(deleteWebLinkFailed(error))
  }
}

function* updateWebLinkOrder({ payload: params }) {
  try {
    const response = yield axiosPut(
      `/admin/menu/container/${params.id}`,
      params,
      {
        menu_item_id: params.menu_item_id,
      }
    )
    yield put(updateWebLinkOrderSuccess(response))
  } catch (error) {
    yield put(updateWebLinkOrderFailed(error))
  }
}

function* updateWebLinkStatus({ payload: params }) {
  try {
    const response = yield axiosPut(
      `/admin/menu/container/${params.id}`,
      params,
      {
        menu_item_id: params.menu_item_id,
      }
    )
    yield put(setIsOutdated(true))
    yield put(updateWebLinkStatusSuccess(response))
  } catch (error) {
    yield put(updateWebLinkStatusFailed(error))
  }
}

function* getWebLinkClicks({ payload: params }) {
  try {
    const response = yield get(`/admin/menu/container/${params?.id}/clicks`, {
      params,
    })
    yield put(getWebLinkClicksSuccess(response))
  } catch (error) {
    yield put(getWebLinkClicksFailed(error))
  }
}

function* webLinkSaga() {
  yield takeEvery(ADD_WEB_LINK, addWebLink)
  yield takeEvery(GET_WEB_LINK, getWebLink)
  yield takeEvery(UPDATE_WEB_LINK, updateWebLink)
  yield takeEvery(GET_WEB_LINK_LIST, getWebLinkList)
  yield takeEvery(DELETE_WEB_LINK, deleteWebLink)
  yield takeEvery(UPDATE_WEB_LINK_ORDER, updateWebLinkOrder)
  yield takeEvery(UPDATE_WEB_LINK_STATUS, updateWebLinkStatus)
  yield takeEvery(GET_WEB_LINK_CLICKS, getWebLinkClicks)
}

export default webLinkSaga
